'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { funnelSchema } from '~/lib/schemas/funnel-schema'
import { useFunnelStore } from '../../_hooks/use-funnel-store'
import type { FunnelStepComponent } from '../../types'
import { FunnelStep } from '../FunnelStep'

const schema = funnelSchema.pick({ first_name: true, last_name: true })

export const Name: FunnelStepComponent = ({ onSubmit }) => {
  const { first_name, last_name } = useFunnelStore.getState().data
  const { control, formState, handleSubmit } = useForm({
    resolver: zodResolver(schema),
    defaultValues: { first_name: first_name ?? '', last_name: last_name ?? '' },
    mode: 'onChange',
  })

  return (
    <FunnelStep onSubmit={handleSubmit(onSubmit)}>
      <FunnelStep.Title>Almost there! What&rsquo;s your name?</FunnelStep.Title>
      <div className="flex flex-col gap-4 tablet:flex-row">
        <div className="w-full max-w-120">
          <FunnelStep.TextInput control={control} name="first_name" placeholder="First Name" autoFocus />
        </div>
        <div className="w-full max-w-120">
          <FunnelStep.TextInput control={control} name="last_name" placeholder="Last Name" />
        </div>
      </div>
      <FunnelStep.Button disabled={!formState.isValid}>Next</FunnelStep.Button>
    </FunnelStep>
  )
}

Name.path = 'name'
Name.schema = schema
